// extracted by mini-css-extract-plugin
export default {"root":"_1026J","collapsed":"_2vN2z"};